import { z } from 'zod'

// Per-platform identifiers for one location — only the keys for platforms
// that actually matched are present (app/api/v4/integrations/targeting/
// targeting.py's TargetingSearchResult.platform_results).
export const platformLocationResultSchema = z
  .object({
    // google
    geo_target_constant_id: z.number().optional(),
    resource_name: z.string().optional(),
    target_type: z.string().optional(),
    reach: z.number().nullable().optional(),
    // fb
    key: z.string().optional(),
    type: z.string().optional(),
    country_code: z.string().optional(),
  })
  .passthrough()

export const platformResultsSchema = z
  .object({
    google: platformLocationResultSchema.optional(),
    fb: platformLocationResultSchema.optional(),
  })
  .passthrough()

export const targetingSearchResultSchema = z
  .object({
    name: z.string(),
    canonical_name: z.string().optional(),
    type: z.string(),
    country_code: z.string().optional(),
    platform_results: platformResultsSchema,
  })
  .passthrough()

export const targetingSearchResponseSchema = z.object({
  results: z.array(targetingSearchResultSchema),
})

export const zipMatchItemSchema = z
  .object({
    zip: z.string(),
    // name/type are filled in by mapZipMatchItem (a matched item is always a
    // zip) — the raw payload carries only zip + platform_results.
    name: z.string().optional(),
    type: z.string().optional(),
    platform_results: platformResultsSchema,
  })
  .passthrough()

export const zipMatchResponseSchema = z.object({
  matched: z.array(zipMatchItemSchema),
  unmatched: z.array(z.string()),
})
